var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('BaseBreadCrumbs'), _c('BaseHeaderLinks', [_vm._t("links")], 2), _vm._t("empty")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }